import React from 'react';

import SplitButton from './SplitButton';
import AddAnswerFromAnotherDepartment from "./addAnswerFromAnotherDepartment";

const DocumentPopupInternalFiles = ({
                                        documentTypes,
                                        refreshCaseFiles,
                                        documentTypesForEditor,
                                        caseInfo,
                                        barcode,
                                        fileId,
                                        userId,
                                        objectOwner,
                                        users,
                                        ownerIdentificationTemplateString,
                                        exploitationIdentificationTemplateString,
                                        permitTypeTitle,
                                        departmentId,
                                        departments,
                                        userAddress
                                    }) => {

    const renderDocumentComponent = (doc) => {
        switch (doc.documentTypeStatus) {
            case 9:
                return (
                    <AddAnswerFromAnotherDepartment
                        onFileAdded={refreshCaseFiles}
                        documentTypes={documentTypesForEditor}
                        docType={doc}
                        objectOwner={objectOwner}
                        buttonTitle={doc.name}
                        fileId={fileId}
                        barcode={barcode}
                        caseInfo={caseInfo}
                        userId={userId}
                        users={users}
                        permitTypeTitle={permitTypeTitle}
                        ownerIdentificationTemplateString={ownerIdentificationTemplateString}
                        exploitationIdentificationTemplateString={exploitationIdentificationTemplateString}
                        departmentId={departmentId}
                        departments={departments}
                        userAddress={userAddress}
                    />
                );
            default:
                return null;
        }
    };
    return (
        <div>
            <SplitButton
                options={documentTypes}
                renderDocumentComponent={renderDocumentComponent}
                buttonLabel="დოკუმენტის შექმნა"
                buttonType={2}
            />
        </div>
    );
};

export default DocumentPopupInternalFiles;
